import React from "react";
import "./App.css";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./features/User/Login";
import Signup from "./features/User/Signup";
import Dashboard from "./features/User/Dashboard";
import { PrivateRoute } from "./helpers/PrivateRoute";
import Home from "./features/Home";
import StartView from "./features/Start";
import Dashboard2 from "./features/Dashboard";
import ComingSoon from "./features/ComingSoon";
import QrGenerator from "./features/QrGenerator";
import UpdatePage from "./features/Update";
import BiodataForm from "./features/components/form/BiodataForm";
import Help from "./features/Help";
import Report from "./features/Report";
import OtherFieldMod from "./features/OtherFieldMod";
import DobUpdateForm from "./features/components/form/DobUpdateForm";
import Otp from "./features/components/otp/Otp";
import StartSignUp from "./features/StartSignUp";
import TrackEnrolment from "./features/TrackEnrolment";
import EnrolmentProfile from "./features/EnrolmentProfile";
import EnrolmentProfile2 from "./features/EnrolmentProfile2";
import "bootstrap/dist/css/bootstrap.min.css";
import ModifyBiodata from "./features/ModifyBioData";
import ViewDetails from "./features/ViewDetails";
import PersonalModification from "./features/PersonalModification";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact component={StartView} path="/getstarted" />
          <Route exact component={StartSignUp} path="/getstarted-signup" />
          <Route exact component={Dashboard2} path="/dashboard" />
          <Route exact component={Home} path="/home" />
          <Route exact component={Help} path="/help" />
          <Route exact component={Report} path="/report" />
          <Route exact component={Login} path="/login" />
          <Route exact component={Otp} path="/otp" />
          <Route exact component={Signup} path="/signup" />
          <PrivateRoute exact component={Dashboard} path="/" />
          <PrivateRoute
            exact
            component={TrackEnrolment}
            path="/track-enrolment"
          />
          <PrivateRoute exact component={ViewDetails} path="/view-details" />
          <PrivateRoute exact component={ModifyBiodata} path="/modification" />
          <PrivateRoute exact component={Help} path="/help2" />
          <PrivateRoute
            exact
            component={PersonalModification}
            path="/personal-modification"
          />
          <PrivateRoute exact component={EnrolmentProfile} path="/profile" />
          <PrivateRoute exact component={EnrolmentProfile2} path="/profile2" />
          <PrivateRoute exact component={BiodataForm} path="/biodata" />
          <PrivateRoute exact component={QrGenerator} path="/qrgenerator" />
          <PrivateRoute exact component={UpdatePage} path="/update" />
          <PrivateRoute exact component={OtherFieldMod} path="/otherfield" />
          <PrivateRoute exact component={DobUpdateForm} path="/dobfield" />
          <Route component={ComingSoon} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
